// extracted by mini-css-extract-plugin
module.exports = {"border":"RoomOptionsSidebarItem_border__3xiKZ","roomInfoHolder":"RoomOptionsSidebarItem_roomInfoHolder__47BhA"};